/* eslint-disable no-unused-vars */

import React, { useState, useEffect, useReducer, useContext } from "react";
import { toast } from "react-toastify";

import { useHistory } from "react-router-dom";

import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Tooltip from "@material-ui/core/Tooltip";

import AddIcon from "@material-ui/icons/Add";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import EditIcon from "@material-ui/icons/Edit";

import MainContainer from "../../components/MainContainer";
import TableRowSkeleton from "../../components/TableRowSkeleton";
import { EmptyState, PageHeader, StatusBadge } from "../../components/ui";

import api from "../../services/api";
import { i18n } from "../../translate/i18n";
import ConfirmationModal from "../../components/ConfirmationModal";
import toastError from "../../errors/toastError";
import { isArray } from "lodash";
import { AuthContext } from "../../context/Auth/AuthContext";
import CampaignModalPhrase from "../../components/CampaignModalPhrase";
import { TextFields, Link as LinkIcon } from "@mui/icons-material";
import { Can } from "../../components/Can";
import { getTokens } from "../../styles/tokens";

const reducer = (state, action) => {
  if (action.type === "LOAD_CAMPAIGNS") {
    const campaigns = action.payload;
    const newCampaigns = [];

    if (isArray(campaigns)) {
      campaigns.forEach((campaign) => {
        const campaignIndex = state.findIndex((u) => u.id === campaign.id);
        if (campaignIndex !== -1) {
          state[campaignIndex] = campaign;
        } else {
          newCampaigns.push(campaign);
        }
      });
    }

    return [...state, ...newCampaigns];
  }

  if (action.type === "UPDATE_CAMPAIGNS") {
    const campaign = action.payload;
    const campaignIndex = state.findIndex((u) => u.id === campaign.id);

    if (campaignIndex !== -1) {
      state[campaignIndex] = campaign;
      return [...state];
    } else {
      return [campaign, ...state];
    }
  }

  if (action.type === "DELETE_CAMPAIGN") {
    const campaignId = action.payload;

    const campaignIndex = state.findIndex((u) => u.id === campaignId);
    if (campaignIndex !== -1) {
      state.splice(campaignIndex, 1);
    }
    return [...state];
  }

  if (action.type === "RESET") {
    return [];
  }
};

const useStyles = makeStyles((theme) => {
  const t = getTokens(theme.palette.type, theme.palette.primary.main);
  return {
    mainPaper: {
      flex: 1,
      minHeight: 0,
      display: "flex",
      flexDirection: "column",
      overflow: "hidden",
      boxShadow: t.shadow.card,
    },
    tableScroll: {
      flex: 1,
      minHeight: 0,
      overflow: "auto",
      ...theme.scrollbarStyles,
    },
    table: { minWidth: 720 },
    campaignName: { fontWeight: 600, color: t.text },
    campaignMeta: { marginTop: 2, fontSize: 12, color: t.textMuted },
    connectionContainer: {
      display: "flex",
      flexWrap: "wrap",
      gap: 6,
      alignItems: "center",
    },
    noConnection: { color: t.textMuted },
    actionsCell: { width: 110, whiteSpace: "nowrap" },
    deleteButton: { color: t.semantic.error },
  };
});

const CampaignsPhrase = () => {
  const classes = useStyles();
  const history = useHistory();
  const { user } = useContext(AuthContext);

  const [loading, setLoading] = useState(true);
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const [deletingContact, setDeletingContact] = useState(null);

  // Estados das campanhas
  const [campaignflows, setCampaignFlows] = useState([]);
  const [ModalOpenPhrase, setModalOpenPhrase] = useState(false);
  const [campaignflowSelected, setCampaignFlowSelected] = useState();

  // Estado para lista de WhatsApps (para exibir nomes)
  const [whatsApps, setWhatsApps] = useState([]);

  const handleDeleteCampaign = async (campaignId) => {
    try {
      await api.delete(`/flowcampaign/${campaignId}`);
      toast.success("Campanha deletada com sucesso");
      getCampaigns();
    } catch (err) {
      toastError(err);
    }
    setConfirmModalOpen(false);
    setDeletingContact(null);
  };

  // Buscar lista de WhatsApps para mostrar nomes
  const getWhatsApps = async () => {
    try {
      const response = await api.get("/whatsapp");
      setWhatsApps(response.data || []);
    } catch (error) {
      console.error('Erro ao buscar WhatsApps:', error);
    }
  };

  const getCampaigns = async () => {
    try {
      setLoading(true);
      const response = await api.get("/flowcampaign");
      
      console.log('Resposta completa da API:', response.data);
      
      // Verificar diferentes estruturas de resposta possíveis
      let flowData = [];
      
      if (response.data) {
        if (Array.isArray(response.data.flow)) {
          flowData = response.data.flow;
        }
        else if (response.data.data && Array.isArray(response.data.data.flow)) {
          flowData = response.data.data.flow;
        }
        else if (Array.isArray(response.data.data)) {
          flowData = response.data.data;
        }
        else if (Array.isArray(response.data)) {
          flowData = response.data;
        }
        else {
          const dataKeys = Object.keys(response.data);
          for (const key of dataKeys) {
            if (Array.isArray(response.data[key])) {
              flowData = response.data[key];
              break;
            }
          }
        }
      }
      
      console.log('Dados das campanhas extraídos:', flowData);
      setCampaignFlows(flowData);
      
    } catch (error) {
      console.error('Erro ao buscar campanhas:', error);
      toastError(error);
      setCampaignFlows([]);
    } finally {
      setLoading(false);
    }
  };

  const onSaveModal = () => {
    getCampaigns();
  };

  const handleOpenNewCampaign = () => {
    setCampaignFlowSelected(undefined);
    setModalOpenPhrase(true);
  };

  // Selo de uma conexão: verde quando conectada, neutro nos demais estados
  const renderWhatsAppBadge = (whatsappId) => {
    const whatsapp = whatsApps.find(w => w.id === whatsappId);
    return (
      <Tooltip key={whatsappId} title={whatsapp ? `${whatsapp.name} (${whatsapp.status})` : `ID: ${whatsappId}`}>
        <span>
          <StatusBadge
            color={whatsapp?.status === "CONNECTED" ? "success" : "neutral"}
            label={whatsapp ? whatsapp.name : `ID: ${whatsappId}`}
          />
        </span>
      </Tooltip>
    );
  };

  const renderWhatsAppConnections = (whatsappIds) => {
    if (!whatsappIds || !Array.isArray(whatsappIds) || whatsappIds.length === 0) {
      return <span className={classes.noConnection}>Nenhuma conexão</span>;
    }

    // Se há muitas conexões, mostrar resumo
    if (whatsappIds.length > 3) {
      const firstTwo = whatsappIds.slice(0, 2);
      const remaining = whatsappIds.length - 2;

      return (
        <div className={classes.connectionContainer}>
          {firstTwo.map(renderWhatsAppBadge)}
          <Tooltip title={`Mais ${remaining} conexão(ões)`}>
            <span>
              <StatusBadge color="brand" dot={false} label={`+${remaining}`} />
            </span>
          </Tooltip>
        </div>
      );
    }

    // Mostrar todas as conexões se forem poucas
    return (
      <div className={classes.connectionContainer}>
        {whatsappIds.map(renderWhatsAppBadge)}
      </div>
    );
  };

  useEffect(() => {
    getCampaigns();
    getWhatsApps(); // Carregar lista de WhatsApps
  }, []);

  return (
    <MainContainer maxWidth>
      <ConfirmationModal
        title={
          deletingContact &&
          `${i18n.t("campaigns.confirmationModal.deleteTitle")} ${
            deletingContact.name
          }?`
        }
        open={confirmModalOpen}
        onClose={() => setConfirmModalOpen(false)}
        onConfirm={() => handleDeleteCampaign(deletingContact.id)}
      >
        {i18n.t("campaigns.confirmationModal.deleteMessage")}
      </ConfirmationModal>
      <CampaignModalPhrase
        open={ModalOpenPhrase}
        onClose={() => setModalOpenPhrase(false)}
        FlowCampaignId={campaignflowSelected}
        onSave={onSaveModal}
      />
      <PageHeader
        title="Campanhas de fluxo"
        subtitle="Organize frases de ativação e conexões para iniciar cada automação."
        badge={
          <StatusBadge
            color="neutral"
            dot={false}
            label={String(campaignflows.length)}
          />
        }
        actions={
          <Button
            variant="contained"
            color="primary"
            startIcon={<AddIcon />}
            onClick={handleOpenNewCampaign}
          >
            Nova campanha
          </Button>
        }
      />
      <Paper className={classes.mainPaper} variant="outlined">
        <div className={classes.tableScroll}>
          <Table size="small" className={classes.table}>
            <TableHead>
              <TableRow>
                <TableCell>Nome</TableCell>
                <TableCell>Conexões</TableCell>
                <TableCell>Status</TableCell>
                <TableCell align="right" className={classes.actionsCell}>
                  {i18n.t("contacts.table.actions")}
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {loading ? (
                <TableRowSkeleton columns={4} />
              ) : campaignflows && Array.isArray(campaignflows) && campaignflows.length > 0 ? (
                campaignflows.map((flow) => (
                  <TableRow key={flow.id}>
                    <TableCell>
                      <div className={classes.campaignName}>
                        {flow.name || 'Nome não definido'}
                      </div>
                      {flow.phrase && Array.isArray(flow.phrase) && (
                        <div className={classes.campaignMeta}>
                          {flow.phrase.length} frase(s) configurada(s)
                        </div>
                      )}
                    </TableCell>
                    <TableCell>
                      {renderWhatsAppConnections(flow.whatsappIds)}
                    </TableCell>
                    <TableCell>
                      <StatusBadge
                        color={flow.status ? "success" : "neutral"}
                        label={flow.status ? "Ativo" : "Desativado"}
                      />
                    </TableCell>
                    <TableCell align="right" className={classes.actionsCell}>
                      <Tooltip title="Editar campanha">
                        <IconButton
                          size="small"
                          aria-label={`Editar campanha ${flow.name || ""}`}
                          onClick={() => {
                            setCampaignFlowSelected(flow.id);
                            setModalOpenPhrase(true);
                          }}
                        >
                          <EditIcon fontSize="small" />
                        </IconButton>
                      </Tooltip>
                      <Can
                        role={user.profile}
                        perform="contacts-page:deleteContact"
                        yes={() => (
                          <Tooltip title="Excluir campanha">
                            <IconButton
                              size="small"
                              className={classes.deleteButton}
                              aria-label={`Excluir campanha ${flow.name || ""}`}
                              onClick={(e) => {
                                setConfirmModalOpen(true);
                                setDeletingContact(flow);
                              }}
                            >
                              <DeleteOutlineIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        )}
                      />
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={4} style={{ borderBottom: "none" }}>
                    <EmptyState
                      icon={<TextFields />}
                      title="Nenhuma campanha encontrada"
                      message="Crie uma campanha para configurar frases de ativação e conexões."
                      action={
                        <Button
                          variant="contained"
                          color="primary"
                          startIcon={<AddIcon />}
                          onClick={handleOpenNewCampaign}
                        >
                          Criar campanha
                        </Button>
                      }
                    />
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </div>
      </Paper>
    </MainContainer>
  );
};

export default CampaignsPhrase;
